import { Platform } from "react-native";
import { Colors } from "../../helpers/colors";

function getAvatarColors() {
  return Object.keys(Colors).map((key) => {
    return Colors[key];
  });
}

const avatarColors: string[] = getAvatarColors();

export function getUserNameColor(userName = "") {
  try {
    return avatarColors[hashCode(userName) % avatarColors.length];
  } catch (err) {
    console.error(err);
    return avatarColors[0];
  }
}

export function hashCode(text = "") {
  let i: number;
  let chr: number;
  let hash: number = 0;

  if (text.length === 0) return hash;
  for (i = 0; i < text.length; i++) {
    chr = text.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + chr;
    // eslint-disable-next-line no-bitwise
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

export function getDisplayNameInitials(displayName = "") {
  try {
    const names = displayName.split(" ");
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    } else {
      return `${names[0]?.charAt(0) ?? ""}${names[1]?.charAt(0) ?? ""}`
        .toUpperCase()
        .trim();
    }
  } catch (err) {
    console.error(err);
  }
}
export const isWeb = Platform.OS === "web";
